import React from 'react';

export function BookOpenIcon(props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
	return (
		<svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<rect x='1' y='1' width='38' height='38' rx='11' stroke='currentColor' strokeWidth={2} />
			<path
				d='M19.25 12.5329C17.7345 11.5628 15.9325 11 14 11C12.8618 11 11.7676 11.1954 10.7501 11.555C10.4504 11.6609 10.25 11.9443 10.25 12.2621V26.5121C10.25 26.7556 10.3682 26.9839 10.567 27.1245C10.7657 27.265 11.0204 27.3004 11.2499 27.2192C12.1091 26.9156 13.0344 26.75 14 26.75C15.995 26.75 17.8232 27.4573 19.25 28.6357V12.5329Z'
				fill='currentColor'
			/>
			<path
				d='M20.75 28.6357C22.1768 27.4573 24.005 26.75 26 26.75C26.9656 26.75 27.8909 26.9156 28.7501 27.2192C28.9796 27.3004 29.2343 27.265 29.433 27.1245C29.6318 26.9839 29.75 26.7556 29.75 26.5121V12.2621C29.75 11.9443 29.5496 11.6609 29.2499 11.555C28.2324 11.1954 27.1382 11 26 11C24.0675 11 22.2655 11.5628 20.75 12.5329V28.6357Z'
				fill='currentColor'
			/>
		</svg>
	);
}
